import React, { useEffect, useState } from 'react'
import { Button, Image, Modal } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import { isMobile } from 'helpers'
import { connectedApiService as api } from 'index'

const isMobileBrowser = isMobile()

const WhatsNewModalPartner = ({
  show,
  onHide,
  values,
  token,
  companyId,
  isMasqueradeUser = false,
  userId,
  user,
  userName,
}) => {
  const history = useHistory()
  const [src, setSrc] = useState(null)

  const onClose = () => {
    onHide()
  }

  const resolveCtaUrl = url => {
    if (!url || !token) return url
    return url.split('{token}').join(token)
  }

  const getReviewerName = () => {
    const firstName = user?.profile?.firstName || user?.firstName || ''
    const lastName = user?.profile?.lastName || user?.lastName || ''
    const fullName = `${firstName} ${lastName}`.trim()
    if (fullName) return fullName
    if (userName && userName !== 'newUser') return userName
    return null
  }

  const onCtaClick = async e => {
    e.preventDefault()
    const resolvedUrl = resolveCtaUrl(values.ctaUrl)
    if (!resolvedUrl) return

    // Only stamp when a real partner opens Documents list (not via masquerade)
    if (
      !isMasqueradeUser &&
      companyId &&
      /\/documents\/service-quality-earning-adjustments\/account(\/|$|\?)/i.test(
        resolvedUrl
      )
    ) {
      try {
        await api.patch(`documentsReviewed/partner/${companyId}`, {
          userId: userId || null,
          name: getReviewerName(),
          token: token || null,
        })
      } catch (error) {
        // non-blocking
      }
    }

    if (/^https?:\/\//i.test(resolvedUrl)) {
      window.open(resolvedUrl, '_blank')
      onClose()
      return
    }

    history.push(resolvedUrl)
    onClose()
  }

  useEffect(() => {
    if (values && values.image && values.image.size) {
      const src =
        values.image && values.image
          ? window.URL.createObjectURL(values.image)
          : null
      setSrc(src)
    }
  }, [values.image])

  return (
    <div style={{ overflow: 'hidden' }}>
      <Modal
        size={isMobileBrowser ? 'md' : 'lg'}
        show={show}
        onHide={onClose}
        backdrop='static'
        className='whats-new-modal'
        dialogClassName='modal-size'
        backdropClassName='whats-new-backdrop'
        aria-labelledby='contained-modal-title-vcenter'
        centered
      >
        <Modal.Body>
          <div className='modal-panel'>
            <div className='modal-div'>
              {values.image && values.image.name && (
                <Image
                  src={src || values.image.name}
                  className='image'
                  width='100%'
                />
              )}
            </div>
            <div
              className='modal-container'
              style={
                (!values.ctaText || !values.ctaUrl) && isMobileBrowser
                  ? { paddingBottom: '45px' }
                  : {}
              }
            >
              <Modal.Header
                style={
                  (!values.ctaText || !values.ctaUrl) && !isMobileBrowser
                    ? { paddingTop: '30px' }
                    : {}
                }
              >
                <Modal.Title
                  id='example-modal-sizes-title-lg'
                  className='modal-title'
                >
                  <div className='close-btn-wrap'>
                    <Button
                      variant='link'
                      className={`${isMobileBrowser ? 'btn-link-mobile' : ''}`}
                      onClick={onClose}
                    >
                      <img src='/images/icons/close-icon-black.png' alt='' />
                    </Button>
                  </div>
                </Modal.Title>
              </Modal.Header>
              <p
                className='whatsnew'
                style={
                  !values.ctaText || !values.ctaUrl ? { marginTop: 0 } : {}
                }
              >
                {values.header}
              </p>
              <p className='title'>{values.title}</p>
              <p className='description'>{values.description}</p>
              {values.ctaText && values.ctaUrl && (
                <div className='cta'>
                  <Button
                    onClick={onCtaClick}
                    className='submit-btn'
                    variant='brown'
                  >
                    {values.ctaText}
                  </Button>
                </div>
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default WhatsNewModalPartner
